import { Form } from 'antd';

export const useWatch = Form.useWatch;
